module.exports = __webpack_public_path__ + "media/images/cardboard-img-01-85b8f1bd41260122eb719ffa0a915acd.jpg";